module.exports = " <select v-model=value @change=onChange> <option v-for=\"opt in cookie.themes | orderBy 'text'\" :value=opt.value :selected=\"opt.value === cookie.theme \">{{ opt.text }}</option> </select> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeSelector.vue
 ** module id = 227
 ** module chunks = 2
 **/